//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { useQuery } from '@tanstack/react-query';

import { getTrackingUrlPreview } from '@apis/universal-image-actions/universalImageActionsApi';
import { TrackingUrlPreviewRequest } from '@apis/universal-image-actions/universalImageActionsApiModel';
import { QueryKeyConstants } from '@queries/QueryKeyConstants';
import { FIVE_MINUTES_STALE_TIME } from '@queries/QueryOptionsConstants';

export const useTrackingUrlPreviewQuery = (
  request: TrackingUrlPreviewRequest,
) =>
  useQuery({
    queryFn: async ({ signal }) => getTrackingUrlPreview(request, { signal }),
    queryKey: [
      QueryKeyConstants.UniversalImageActions,
      QueryKeyConstants.UniversalImageActionsProducts,
      QueryKeyConstants.UniversalImageActionsProductsTrackingParams,
      QueryKeyConstants.UniversalImageActionsProductsTrackingUrlPreview,
      request,
    ],
    staleTime: FIVE_MINUTES_STALE_TIME,
    enabled: !!request.url,
  });
